<svg-icon 
    src="{{ url }}" 
    class="app-icon" 
    [ngClass]="classes" 
    [svgStyle]="{ 'width.rem': size.toString()}"> 
</svg-icon>
